// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"535":"3926b344","741":"9196cf16","2264":"77251017","3088":"bd8a3f70","5607":"1bd470dc","5947":"6783947a","8199":"4f3ea58e","8985":"a391a6e0"}[chunkId] + ".chunk.css";
};